import React, { useState, useEffect } from "react";
import { AssetsProvider } from "./assets/AssetsContext";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
// import { isMobile } from "react-device-detect";
// import { Helmet } from "react-helmet-async";
//import { Route, Routes, useLocation } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
// import metaData from "./Components/metaData";
import Home from "./components/Home";
import About from "./components/About";
import AccelTrack from "./components/AccelTrack";
import AccelAlert from "./components/AccelAlert";
import AccelSupply from "./components/AccelSupply";
import TheFifthClimate from "./components/TheFifthClimate";
import HydroTRACE from "./components/HydroTRACE";
import WaterManagement from "./components/WaterManagement";
import VoiceOfCustomer from "./components/VoiceOfCustomer";
import Contact from "./components/Contact";
import GreenPledge from "./components/GreenPledge";
import Leadership from "./components/Leadership";
import Careers from "./components/Careers";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Blogs from "./components/Blogs";
import News from "./components/News";
import LatestNewsDetails from "./components/LatestNewsDetails";
import EventDetail from "./components/EventDetail";
import Events from "./components/Events";
import Bioforge from "./components/Bioforge";
import BlogDetailPage from "./components/BlogDetailPage";
import HydrotracePage from "./components/HydrotracePage";
import AtmosPOD from "./components/AtmosPOD";
import { assets } from "./assets/assets";

function App() {
  return (
    <div className="App">
      <AssetsProvider>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/TheFifthClimate" element={<TheFifthClimate />} />
          <Route path="/climate/HydroTRACE" element={<HydrotracePage />} />
          <Route path="/climate/AtmosPOD" element={<AtmosPOD />} />

          <Route path="/climate/acceltrack" element={<AccelTrack />} />
          <Route path="/climate/accelalert" element={<AccelAlert />} />
          <Route path="/climate/accelsupply" element={<AccelSupply />} />
          <Route path="/climate/bioforge" element={<Bioforge />} />
          <Route path="/climate/hydrotrace" element={<HydroTRACE />} />

          <Route
            path="/climate/water-management"
            element={<WaterManagement />}
          />

          <Route path="/customers/voice" element={<VoiceOfCustomer />} />

          <Route path="/company/about" element={<About />} />
          <Route path="/company/contact" element={<Contact />} />
          <Route path="/company/green-pledge" element={<GreenPledge />} />
          <Route path="/company/leadership" element={<Leadership />} />
          <Route path="/company/careers" element={<Careers />} />
          <Route path="/company/privacy" element={<PrivacyPolicy />} />

          <Route path="/resources/blogs" element={<Blogs />} />
          <Route path="/blog/:id" element={<BlogDetailPage />} />
          <Route path="/resources/news" element={<News />} />
          <Route path="/news/:id" element={<LatestNewsDetails />} />
          <Route path="/event/:id" element={<EventDetail />} />
          <Route path="/resources/events" element={<Events />} />

          {/* <Route path="/contact-us" element={<Contactus />} /> */}
        </Routes>
        <Footer />
      </AssetsProvider>
    </div>
  );
}

export default App;
